import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import Collection from './Collection';
import IndexOutOfBoundsException from '../lang/IndexOutOfBoundsException';
import List from './List';
import NoSuchElementException from './NoSuchElementException';

/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/ArrayList.html
 */
var ArrayList = /*#__PURE__*/function (_List) {
  _inherits(ArrayList, _List);
  function ArrayList(o) {
    var _this;
    _classCallCheck(this, ArrayList);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ArrayList).call(this));
    _this.array = [];
    if (o instanceof Collection) _this.addAll(o);
    return _this;
  }
  _createClass(ArrayList, [{
    key: "ensureCapacity",
    value: function ensureCapacity() {}
  }, {
    key: "add",
    value: function add(e) {
      if (arguments.length === 1) this.array.push(e);else this.array.splice(arguments[0], 0, arguments[1]);
      return true;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.array = [];
    }
  }, {
    key: "addAll",
    value: function addAll(c) {
      var _iterator = _createForOfIteratorHelper(c),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var e = _step.value;
          this.array.push(e);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "set",
    value: function set(index, element) {
      var oldElement = this.array[index];
      this.array[index] = element;
      return oldElement;
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return new Iterator(this);
    }
  }, {
    key: "get",
    value: function get(index) {
      if (index < 0 || index >= this.size()) throw new IndexOutOfBoundsException();
      return this.array[index];
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.array.length === 0;
    }
  }, {
    key: "sort",
    value: function sort(comparator) {
      if (comparator) this.array.sort(function (a, b) {
        return comparator.compare(a, b);
      });else this.array.sort();
    }
  }, {
    key: "size",
    value: function size() {
      return this.array.length;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return this.array.slice();
    }
  }, {
    key: "remove",
    value: function remove(o) {
      for (var i = 0, len = this.array.length; i < len; i++) if (this.array[i] === o) return !!this.array.splice(i, 1);
      return false;
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.array.values();
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [List, Collection];
    }
  }]);
  return ArrayList;
}(List);
export { ArrayList as default };
var Iterator = /*#__PURE__*/function () {
  function Iterator(arrayList) {
    _classCallCheck(this, Iterator);
    this.arrayList = arrayList;
    this.position = 0;
  }
  _createClass(Iterator, [{
    key: "next",
    value: function next() {
      if (this.position === this.arrayList.size()) throw new NoSuchElementException();
      return this.arrayList.get(this.position++);
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      return this.position < this.arrayList.size();
    }
  }, {
    key: "set",
    value: function set(element) {
      return this.arrayList.set(this.position - 1, element);
    }
  }, {
    key: "remove",
    value: function remove() {
      this.arrayList.remove(this.arrayList.get(this.position));
    }
  }]);
  return Iterator;
}();